var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 62,
    viewBox: "0 0 38 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_58_885)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_58_885",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 59,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 35,
    height: 59
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 55.2002H26.2002V49.3994H20.4004L20.4004 8.7998L26.2002 8.7998V3L32 3L32 55.2002ZM20.3994 43.6006H14.5996L14.5996 37.7998H8.7998V32H3L3 26.2002H8.7998L8.7998 20.4004H14.5996V14.6006H20.3994L20.3994 43.6006Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 55.2002H26.2002V49.3994H20.4004L20.4004 8.7998L26.2002 8.7998V3L32 3L32 55.2002ZM20.3994 43.6006H14.5996L14.5996 37.7998H8.7998V32H3L3 26.2002H8.7998L8.7998 20.4004H14.5996V14.6006H20.3994L20.3994 43.6006Z",
    fill: "#527E82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 55.2002V58.2002L35 58.2002V55.2002L32 55.2002ZM26.2002 55.2002H23.2002V58.2002H26.2002V55.2002ZM26.2002 49.3994H29.2002L29.2002 46.3994H26.2002L26.2002 49.3994ZM20.4004 49.3994H17.4004V52.3994H20.4004V49.3994ZM20.4004 8.7998V5.7998H17.4004V8.7998H20.4004ZM26.2002 8.7998V11.7998H29.2002V8.7998H26.2002ZM26.2002 3V0L23.2002 0V3L26.2002 3ZM32 3H35V0H32V3ZM20.3994 43.6006V46.6006H23.3994V43.6006H20.3994ZM14.5996 43.6006H11.5996V46.6006H14.5996V43.6006ZM14.5996 37.7998H17.5996V34.7998H14.5996V37.7998ZM8.7998 37.7998H5.7998L5.7998 40.7998H8.7998V37.7998ZM8.7998 32H11.7998V29H8.7998V32ZM3 32H0V35H3V32ZM3 26.2002L3 23.2002H0L0 26.2002H3ZM8.7998 26.2002V29.2002H11.7998V26.2002H8.7998ZM8.7998 20.4004V17.4004H5.7998V20.4004H8.7998ZM14.5996 20.4004V23.4004H17.5996V20.4004H14.5996ZM14.5996 14.6006V11.6006H11.5996V14.6006H14.5996ZM20.3994 14.6006H23.3994V11.6006H20.3994V14.6006ZM32 55.2002V52.2002H26.2002V55.2002V58.2002H32V55.2002ZM26.2002 55.2002H29.2002V49.3994H26.2002H23.2002V55.2002H26.2002ZM26.2002 49.3994L26.2002 46.3994H20.4004L20.4004 49.3994V52.3994H26.2002V49.3994ZM20.4004 49.3994H23.4004L23.4004 8.7998L20.4004 8.7998H17.4004L17.4004 49.3994H20.4004ZM20.4004 8.7998V11.7998L26.2002 11.7998V8.7998V5.7998L20.4004 5.7998V8.7998ZM26.2002 8.7998H29.2002V3L26.2002 3L23.2002 3V8.7998H26.2002ZM26.2002 3V6L32 6V3V0L26.2002 0V3ZM32 3L29 3L29 55.2002H32L35 55.2002L35 3H32ZM20.3994 43.6006V40.6006H14.5996L14.5996 43.6006V46.6006H20.3994V43.6006ZM14.5996 43.6006H17.5996L17.5996 37.7998H14.5996H11.5996L11.5996 43.6006H14.5996ZM14.5996 37.7998V34.7998H8.7998V37.7998V40.7998H14.5996V37.7998ZM8.7998 37.7998H11.7998V32H8.7998H5.7998V37.7998H8.7998ZM8.7998 32V29H3L3 32V35H8.7998V32ZM3 32H6L6 26.2002H3H0L0 32H3ZM3 26.2002L3 29.2002H8.7998V26.2002V23.2002H3L3 26.2002ZM8.7998 26.2002H11.7998L11.7998 20.4004H8.7998H5.7998L5.7998 26.2002H8.7998ZM8.7998 20.4004L8.7998 23.4004H14.5996V20.4004V17.4004H8.7998V20.4004ZM14.5996 20.4004H17.5996V14.6006H14.5996H11.5996V20.4004H14.5996ZM14.5996 14.6006V17.6006H20.3994V14.6006V11.6006H14.5996V14.6006ZM20.3994 14.6006H17.3994L17.3994 43.6006H20.3994H23.3994L23.3994 14.6006H20.3994Z",
    fill: "#062435",
    mask: "url(#path-1-outside-1_58_885)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_58_885",
    x: 0,
    y: 0,
    width: 38,
    height: 61.2002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.203922 0 0 0 0 0.270588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_58_885"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_58_885",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLeft);
export default __webpack_public_path__ + "static/media/img_left.368b890d4a27d332b0af6dd29d157a51.svg";
export { ForwardRef as ReactComponent };